import React from "react";
import axios from "axios";

import {BrowserRouter} from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import {Toaster} from "react-hot-toast";
import Routes from "./routes";
import "./saas/_app.scss";
import AuthProvider from "./AuthProvider";
import cookie from "./utils/cookie";

const token = cookie.get("jwt");
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.baseURL = process.env.REACT_APP_AXIOS_BASE_URL;
// axios.defaults.baseURL = "https://phplaravel-959325-3423130.cloudwaysapps.com/";
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`; 

function App() {
    return (
        <>
            <Toaster toastOptions={{position: "bottom-center"}}/>
            <BrowserRouter>
                <AuthProvider>
                    <Routes/>
                </AuthProvider>
            </BrowserRouter>
        </>
    );
}

export default App;
